import axios from 'axios';
import apiConfig from '../../api.config';

export default async function getSelectOptions() {
  const {
    host,
    URIs: { hbxChannelSelectOptions },
  } = apiConfig;

  const uri = `${host}${hbxChannelSelectOptions}`;

  return await axios.get(uri).then(res => res.data);
}
